import { useEffect, useRef, useState } from 'react';
import { whyUsIntro, valueChain } from '../data/siteData';
import Reveal from './Reveal';
import './WhyUs.css';

function WhyUs() {
  const chainRef = useRef(null);
  const [chainVisible, setChainVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const el = chainRef.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setChainVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="why-us" className="section why-us">
      <div className="section-inner">
        <Reveal variant="up" className="why-us-heading">
          <span className="eyebrow">{whyUsIntro.eyebrow}</span>
          <h2>
            {whyUsIntro.heading[0]}
            <span className="accent">{whyUsIntro.heading[1]}</span>
            {whyUsIntro.heading[2]}
          </h2>
          <p>{whyUsIntro.subtext}</p>
        </Reveal>

        <Reveal variant="up" delay={120} className="value-chain-label">
          Our Value Chain — Fully In-House
        </Reveal>

        <div className={`value-chain ${chainVisible ? 'is-visible' : ''}`} ref={chainRef}>
          {valueChain.map((step, i) => {
            const isActive = i === activeIndex;
            return (
              <div
                key={step.number}
                className={`value-chain-step ${isActive ? 'is-active' : ''}`}
                onClick={() => setActiveIndex(i)}
              >
                <span className="value-chain-number">{step.number}</span>
                <h3 className="value-chain-title">{step.title}</h3>
                <p className="value-chain-desc">{step.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
